import React, { memo } from 'react'
import LineCalendarIcon from 'components/Luxkit/Icons/line/LineCalendarIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'

interface Props {
  durationLabel: string;
}

function FlashTourDurationLabel(props: Props) {
  const { durationLabel } = props

  return <BodyTextBlock variant="medium" format="titlecase" weight="bold" startIcon={<LineCalendarIcon colour="primary" />}>
    {durationLabel}
  </BodyTextBlock>
}

export default memo(FlashTourDurationLabel)
